import { Box, Theme } from '@mui/material';
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  sx?: object;
}

const Card: React.FC<CardProps> = ({ children, sx = {} }) => (
  <Box
    sx={[
      (theme: Theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: `${theme.borderRadius.xl}px`,
        boxShadow: theme.customShadows.card,
        padding: theme.spacing(4, 3),
      }),
      sx as object,
    ]}
  >
    {children}
  </Box>
);

export default Card;
